/**
 * Register a service worker and log lifecycle events.
 * No-op in environments without service worker support.
 */
export async function registerServiceWorker(swPath: string): Promise<void> {
  if (!('serviceWorker' in navigator)) return;

  try {
    const reg = await navigator.serviceWorker.register(swPath);
    console.log('[sw] registered:', swPath);

    reg.addEventListener('updatefound', () => {
      const newWorker = reg.installing;
      if (!newWorker) return;

      console.log('[sw] update found, installing...');

      newWorker.addEventListener('statechange', () => {
        console.log('[sw] state:', newWorker.state);
      });
    });
  } catch (err) {
    console.warn('[sw] registration failed:', err);
  }
}
